import { createStyles, Theme } from '@material-ui/core';

export default (theme: Theme) => {
  const {
    spacing: { unit },
  } = theme;

  return createStyles({
    container: {
      height: '100%',
      overflow: 'auto',
      padding: unit * 2,
      display: 'flex',
      flexDirection: 'column',
      gap: `${unit * 2}px`,
    },
  });
};
